'use strict';

var researchModule = angular.module("app.researchModule", []);


researchModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider: ng.ui.IStateProvider, $locationProvider: angular.ILocationProvider) {

        console.log('app.researchModule config...');
        var wholesaleClientChecker = ['sessionService', '$q', '$state', 'userCompanyService', function (sessionService, $q, $state,userCompanyService) {
          var deferred = $q.defer();
          userCompanyService.getUserCompany().then((company) => {
            if (sessionService.getCurrentUserProfile().wholesaleclient === 'True' && !company.enableWholesaleClientsResearch) {
              $state.go('dashboard');
              deferred.reject();
            } else {
              deferred.resolve();
            }
          })
          return deferred.promise;
        }]
        $stateProvider
          .state("privateWealth",
            {
                url: "/privateWealthResearch?articleId",
                templateUrl: "assets/templates/Research/privateWealth.html",
                controller: "privateWealthCtrl",
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Private Wealth Research"};
                  }],
                   wholesaleClientCheck: wholesaleClientChecker
                }
            })
            // .state("strategy",
            // {
            //     url: "/strategy?articleId",
            //     templateUrl: "assets/templates/Research/Strategy.html",
            //     controller: "strategyCtrl",
            //     resolve: {
            //        wholesaleClientCheck: wholesaleClientChecker,
            //        impersonatorCheck: ['sessionService', '$q','$state', function(sessionService, $q, $state) {
            //          var deferred = $q.defer();
            //          if (sessionService.getCurrentUserProfile().impersonator === 'True') {
            //            $state.go('dashboard');
            //            deferred.reject();
            //          } else {
            //            deferred.resolve();
            //          }
            //          return deferred.promise;
            //        }]
            //     }
            // })
            // .state('quantitativeAnalysis', {
            //     url: '/quantitativeAnalysis',
            //     templateUrl: 'assets/templates/research/quantitativeAnalysis.html',
            //     controller: "quantitativeAnalysisCtrl",
            //     resolve: {
            //        wholesaleClientCheck: wholesaleClientChecker,
            //        impersonatorCheck: ['sessionService', '$q','$state', function(sessionService, $q, $state) {
            //          var deferred = $q.defer();
            //          if (sessionService.getCurrentUserProfile().impersonator === 'True') {
            //            $state.go('dashboard');
            //            deferred.reject();
            //          } else {
            //            deferred.resolve();
            //          }
            //          return deferred.promise;
            //        }]
            //    }
            // })
            .state('article', {
                url: '/article/:section/:articleId',
                templateUrl: 'assets/templates/research/article.html',
                controller: "articleCtrl",
                resolve: {
                  //resolve the title a bit differently - get the article first 
                  article: ['$rootScope', '$stateParams','$q','researchFeedService', function ($rootScope, $stateParams, $q, researchFeedService) {
                    var deferred = $q.defer();
                    researchFeedService.getArticle($stateParams['articleId'])
                      .then(article => {
                        if(article.id){
                          $rootScope.meta = {title: article.title};
                          deferred.resolve(article);
                        }else{
                          $rootScope.meta = {title: "Article Not Available"};
                          deferred.resolve();
                        }

                      },
                      (reason) => {
                        $rootScope.meta = {title: "Article Not Available"};
                        deferred.resolve();
                      });
                    return deferred.promise;
                  }],
                   wholesaleClientCheck: wholesaleClientChecker
               }
            })
            .state('companyResearch', {
                url: '/companyResearch',
                templateUrl: 'assets/templates/research/companyResearch.html',
                controller: 'companyResearchCtrl',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Company Research"};
                  }],
                   wholesaleClientCheck: wholesaleClientChecker
               }
            })
            .state('equitiesResearch', {
              url: '/equitiesResearch',
              templateUrl: 'assets/templates/research/equitiesResearch.html',
              controller: 'equitiesResearchCtrl',
              resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                  $rootScope.meta = {title: "Equities Research"};
                }],
                wholesaleClientCheck: wholesaleClientChecker
              }
            })
          .state('fundResearch', {
            url: '/fundResearch',
            templateUrl: 'assets/templates/research/fundResearch.html',
            controller: 'fundResearchCtrl',
            resolve: {
              meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                $rootScope.meta = {title: "Fund Research"};
              }],
              wholesaleClientCheck: wholesaleClientChecker
            }
          })
          .state('etfResearch', {
            url: '/etfResearch',
            templateUrl: 'assets/templates/research/etfResearch.html',
            controller: 'etfResearchCtrl',
            resolve: {
              meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                $rootScope.meta = {title: "ETF Research"};
              }],
              wholesaleClientCheck: wholesaleClientChecker
            }
          })
          .state('recentResearch', {
            url: '/recentResearch',
            templateUrl: 'assets/templates/research/recentResearch.html',
            controller: 'recentResearchCtrl',
            resolve: {
              meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                $rootScope.meta = {title: "Recent Equities Research"};
              }],
              wholesaleClientCheck: wholesaleClientChecker
            }
          })
          .state('asxAnnouncements', {
            url: '/asxAnnouncements',
            templateUrl: 'assets/templates/research/asxAnnouncements.html',
            controller: 'asxAnnouncementsCtrl',
            resolve: {
              meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                $rootScope.meta = {title: "ASX Announcements"};
              }],
              wholesaleClientCheck: wholesaleClientChecker
            }
          })
          .state('search', {
            url: '/search',
            templateUrl: 'assets/templates/research/quickSearch.html',
            controller: 'quickSearchCtrl',
            resolve: {
              meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                $rootScope.meta = {title: "Quick Search"};
              }],
              wholesaleClientCheck: wholesaleClientChecker
            }
          })
    }]);

researchModule.controller('researchBaseCtrl', Patersons.ResearchBaseCtrl);
researchModule.controller('strategyCtrl', Patersons.StrategyCtrl);
researchModule.controller('privateWealthCtrl', Patersons.PrivateWealthCtrl);
researchModule.controller('quantitativeAnalysisCtrl', Patersons.QuantitativeAnalysisCtrl);
researchModule.controller('companyResearchCtrl', Patersons.CompanyResearchCtrl);
researchModule.controller('equitiesResearchCtrl', Patersons.EquitiesResearchCtrl);
researchModule.controller('fundResearchCtrl', Patersons.FundResearchCtrl);
researchModule.controller('etfResearchCtrl', Patersons.ETFResearchCtrl);
researchModule.controller('quickSearchCtrl', Patersons.QuickSearchCtrl);
researchModule.controller('recentResearchCtrl', Patersons.RecentResearchCtrl);
researchModule.controller('asxAnnouncementsCtrl', Patersons.ASXAnnouncementsCtrl);

researchModule.controller('articleCtrl', Patersons.ArticleCtrl);
